import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { CreateContactingDto, SupportDetailDto, UpdateContactingDto } from "../../models/support.models";
import { FormSelectModelDto } from "../../../payment-link-list/models/paylinks.model";
import { SupportDataService } from "../../services/support-data.service";
import { map, Subscription } from "rxjs";
import { FileNameSetService } from "../../../../services/file-name-set.service";
import { NgxFileDropEntry } from "ngx-file-drop";
import { SupportDetailUpdateService } from "../../services/support-detail-update.service";
import { FilesToStringService } from "../../../../services/files-to-string.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-contacting-support-detail",
  templateUrl: "./contacting-support-detail.component.html",
  styleUrls: ["./contacting-support-detail.component.scss"],
})
export class ContactingSupportDetailComponent implements OnInit, OnDestroy {
  @Input() supportTypeList: FormSelectModelDto[] = [];
  @Input() supportStatusList: FormSelectModelDto[] = [];

  @Output() closeWithoutEdit: EventEmitter<string> = new EventEmitter<string>();
  @Output() editedContactingEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() fileNotLoadedEvent: EventEmitter<void> = new EventEmitter<void>();

  selectedSupportItem: SupportDetailDto | undefined;
  supportTypeSelected: FormSelectModelDto | undefined;
  supportStatusSelected: FormSelectModelDto | undefined;

  text = "";

  isEditSupport = false;

  subs: Subscription[] = [];

  fileName = "";

  files: NgxFileDropEntry[] = [];

  contFile = 0;

  isSending = false;

  form!: FormGroup;

  constructor(
    private supportDataService: SupportDataService,
    private fileNameSetService: FileNameSetService,
    private supportDetailUpdateService: SupportDetailUpdateService,
    private filesToStringService: FilesToStringService
  ) {}

  ngOnInit() {
    this.formInit();
    this.getAttachedFileList();
    this.initSupportDetail();
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  formInit() {
    this.form = new FormGroup({
      commentFormControl: new FormControl({ value: null, disabled: true }, [Validators.required]),
      typeFormControl: new FormControl({ value: null, disabled: true }, [Validators.required]),
    });
  }

  get commentRequiredError() {
    return this.form.get("commentFormControl")?.hasError("required");
  }

  getAttachedFileList() {
    this.subs.push(
      this.fileNameSetService.setFileName$.subscribe({
        next: (res) => {
          this.fileName = res;
        },
      })
    );
  }

  initSupportDetail() {
    this.subs.push(
      this.supportDetailUpdateService.selectedSupportItem$.subscribe({
        next: (res) => {
          this.isEditSupport = false;
          this.files = [];
          this.form.controls["commentFormControl"].disable();
          this.form.controls["typeFormControl"].disable();

          this.selectedSupportItem = res;
          this.form.controls["commentFormControl"].setValue(this.selectedSupportItem.text);
          this.contFile = res.file_attached.length;
        },
      })
    );

    this.subs.push(
      this.supportDetailUpdateService.supportTypeSelected$.subscribe({
        next: (res) => {
          this.form.controls["typeFormControl"].setValue(res?.value);
        },
      })
    );

    this.subs.push(
      this.supportDetailUpdateService.supportStatusSelected$.subscribe({
        next: (res) => {
          this.supportStatusSelected = res;
        },
      })
    );
  }

  downloadFile(id: string) {
    this.supportDataService.fileDownload(id).subscribe({
      next: (res) => {
        let link = document.createElement("a");
        link.href = (window.webkitURL || window.URL).createObjectURL(res);
        link.download = this.fileName;
        link.click();
      },
    });
  }

  dropped(files: NgxFileDropEntry[]) {
    for (const droppedFile of files) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        const type = file.name.substring(file.name.lastIndexOf(".") + 1);
        const allowedTypes = ["jpg", "jpeg", "bmp", "gif", "png", "doc", "docx", "pdf", "xlsx", "xls", "rar", "zip"];
        if (file.size / 1048576 <= 10 && this.files.length <= 4 - this.contFile && allowedTypes.includes(type.toLocaleLowerCase())) {
          this.files.push(droppedFile);
        } else {
          this.fileNotLoadedEvent.emit();
        }
      });
    }
  }

  fileOver(event: any) {
    // console.log(event);
  }

  fileLeave(event: any) {
    // console.log(event);
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  toggleEdit() {
    this.isEditSupport = !this.isEditSupport;
    this.files = [];
    if (!this.isEditSupport) {
      this.closeWithoutEdit.emit(this.selectedSupportItem?.support_id);
      this.form.controls["commentFormControl"].disable();
      this.form.controls["typeFormControl"].disable();
    } else {
      this.form.controls["commentFormControl"].enable();
      this.form.controls["typeFormControl"].enable();
    }
  }

  saveConnecting() {
    this.isSending = true;
    this.filesToStringService.toFilesBase64(this.files).subscribe({
      next: (res) => {
        const data: UpdateContactingDto = {
          text: this.form.controls["commentFormControl"].value,
          support_type: this.form.controls["typeFormControl"].value,
          files: res,
        };

        this.supportDataService.updateContacting(data, this.selectedSupportItem!.support_id).subscribe({
          next: () => {
            this.editedContactingEvent.emit();
            this.isEditSupport = false;
            this.isSending = false;
          },
          error: () => {
            this.isSending = false;
          },
        });
      },
    });
  }
}
